module.exports = __webpack_public_path__ + "static/media/payments.6fe151dc.svg";